import Axios from "axios";
import CONFIG from "../../../../model/TSConfig";
import type SubscriptionPlanDTO from "@tootsweet/model/datatransfer/SubscriptionPlanDTO";
import CurrencySubUnitsMap from "../../../../model/CurrencySubUnitsMap";

const subscriptionURL = `${CONFIG.saasBackendUrl}/subscription`;

export interface SubscriptionPlansResponse {
  currencySubUnits: CurrencySubUnitsMap;
  currency: string;
  countryCode: string;
  plans: SubscriptionPlanDTO[];
}

export async function fetchSubscriptionPlan(): Promise<SubscriptionPlansResponse> {
  // token: string
  const res = await Axios({
    method: "GET",
    url: `${subscriptionURL}/plan`
    // headers: { Authorization: `Bearer ${token}` }
  });

  return res.data;
}
